module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Crop-65ba2b7f369cda650be288a5fddb3632.svg";